import { render, staticRenderFns } from "./PercentageCalculatorView.vue?vue&type=template&id=004c450c&"
import script from "./PercentageCalculatorView.vue?vue&type=script&lang=js&"
export * from "./PercentageCalculatorView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports